import script from "./SocialFundClassificationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundClassificationDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundClassificationDialog.vue?vue&type=style&index=0&id=67d7c974&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d7c974"]])

export default __exports__